import { TeamRole } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

export function mapSettingToText(setting: Array<TeamRole>) {
  if (setting.length === 0) {
    return translate('No one');
  }

  if (
    setting.length === [TeamRole.Admin, TeamRole.Member, TeamRole.Owner].length
  ) {
    return translate('Everyone');
  }

  return translate('{0} only').format(
    setting
      .filter((role) => role !== TeamRole.Owner) // Filter out the owner role for orgs.
      .map((role) => TeamRole[role])
      .join(', ')
  );
}
